"use strict";

exports.__esModule = true;
exports.ie11fingerprint = ie11fingerprint;
exports.weakMapMethods = exports.setMethods = exports.mapMethods = void 0;
var _getLength = _interopRequireDefault(require("./_getLength.js"));
var _isFunction = _interopRequireDefault(require("./isFunction.js"));
var _allKeys = _interopRequireDefault(require("./allKeys.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Since the regular `Object.prototype.toString` type tests don't work for
// some types in IE 11, we use a fingerprinting heuristic instead, based
// on the methods. It's not great, but it's the best we got.
// The fingerprint method lists are defined below.
function ie11fingerprint(methods) {
  var length = (0, _getLength.default)(methods);
  return function (obj) {
    if (obj == null) return false;
    // `Map`, `WeakMap` and `Set` have no enumerable keys.
    var keys = (0, _allKeys.default)(obj);
    if ((0, _getLength.default)(keys)) return false;
    for (var i = 0; i < length; i++) {
      if (!(0, _isFunction.default)(obj[methods[i]])) return false;
    }
    // If we are testing against `WeakMap`, we need to ensure that
    // `obj` doesn't have a `forEach` method in order to distinguish
    // it from a regular `Map`.
    return methods !== weakMapMethods || !(0, _isFunction.default)(obj[forEachName]);
  };
}

// In the interest of compact minification, we write
// each string in the fingerprints only once.
var forEachName = 'forEach',
  hasName = 'has',
  commonInit = ['clear', 'delete'],
  mapTail = ['get', hasName, 'set'];

// `Map`, `WeakMap` and `Set` each have slightly different
// combinations of the above sublists.
var mapMethods = exports.mapMethods = commonInit.concat(forEachName, mapTail),
  weakMapMethods = exports.weakMapMethods = commonInit.concat(mapTail),
  setMethods = exports.setMethods = ['add'].concat(commonInit, forEachName, hasName);